import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useCachedResource } from "../hooks/useCachedResource";
import { AppShell } from "../components/layout/AppShell";
import { listJoinRequests } from "../api/onboarding";
import { listBranches } from "../api/directory";
import { RequestCard } from "../features/admin/RequestCard";
import { ApprovalsSection } from "../features/hr/ApprovalsSection";
import { RequestsHistory } from "../features/hr/RequestsHistory";
import { RequestTabs, kindsForTab } from "../features/hr/RequestTabs";

// شاشة «الموافقات»: فلاتر سريعة أعلى الصفحة + طلبات الانضمام + السلف والإجازات والزمنية والاستقالات.
export default function RequestsPage() {
  const { t } = useTranslation();
  const [tab, setTab] = useState("all");
  const { data, loading, reload } = useCachedResource("requests", async () => {
    const [reqs, brs] = await Promise.all([listJoinRequests(), listBranches()]);
    return { reqs, brs };
  });
  const requests = data?.reqs || [];
  const branches = data?.brs || [];
  const kinds = kindsForTab(tab);
  const showJoin = tab === "all" || tab === "join";
  const showWork = tab !== "join";

  return (
    <AppShell title={t("requests.title")} subtitle={t("requests.subtitle")}>
      <div className="mb-6">
        <RequestTabs value={tab} onChange={setTab} />
      </div>
      {showJoin ? (
        <div className="grid gap-4">
          {loading ? (
            <p className="text-sm text-muted-foreground">{t("app.loading")}</p>
          ) : requests.length === 0 ? (
            <p className="text-sm text-muted-foreground" data-testid="requests-empty">{t("requests.empty")}</p>
          ) : (
            <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-testid="requests-list">
              {requests.map((r) => (
                <RequestCard key={r.id} request={r} branches={branches} reload={reload} />
              ))}
            </div>
          )}
        </div>
      ) : null}
      {showWork ? (
        <div className={showJoin ? "mt-8 border-t border-border/50 pt-6" : ""}>
          <ApprovalsSection kinds={kinds} />
        </div>
      ) : null}
      {showWork ? (
        <div className="mt-8 border-t border-border/50 pt-6">
          <RequestsHistory kinds={kinds} />
        </div>
      ) : null}
    </AppShell>
  );
}
